let host, procurementApiHost, labsApiHost, apiKey, mainApiHost, fileApiHost;
const hostName = window && window.location && window.location.hostname;
if (hostName === 'seller.dentira.com') {
	host = 'US';
	mainApiHost = `https://mainapi.dentira.com`;
	fileApiHost = 'https://presign.dentira.com';
	procurementApiHost = `https://sellerapi.dentira.com`;
	labsApiHost = `https://labs-sellerapi.dentira.com`;
	apiKey = 'fb4a6b72-a08a-4331-8d95-c7046ec6cd22';
} else if (hostName === 'ca-seller.dentira.com') {
	host = 'CA';
	mainApiHost = `https://123api.dentira.com`;
	fileApiHost = 'https://ca-presign.dentira.com';
	procurementApiHost = `https://ca-sellerapi.dentira.com`;
	labsApiHost = `https://ca-labs-sellerapi.dentira.com`;
	apiKey = 'fb4a6b72-a08a-4331-8d95-c7046ec6cd22';
} else if (hostName === 'au-seller.dentira.com') {
	host = 'AU';
	mainApiHost = `https://au-api.dentira.com`;
	fileApiHost = 'https://au-presign.dentira.com';
	procurementApiHost = `https://au-sellerapi.dentira.com`;
	labsApiHost = `https://au-labs-sellerapi.dentira.com`;
	apiKey = 'fb4a6b72-a08a-4331-8d95-c7046ec6cd22';
} else if (hostName === 'nz-seller.dentira.com') {
	host = 'NZ';
	mainApiHost = `https://nz-api.dentira.com`;
	fileApiHost = 'https://nz-presign.dentira.com';
	procurementApiHost = `https://nz-sellerapi.dentira.com`;
	labsApiHost = `https://nz-labs-sellerapi.dentira.com`;
	apiKey = 'fb4a6b72-a08a-4331-8d95-c7046ec6cd22';
} else if (hostName === 'uk-seller.dentira.com') {
	host = 'UK';
	mainApiHost = `https://uk-api.dentira.com`;
	fileApiHost = 'https://uk-presign.dentira.com';
	procurementApiHost = `https://uk-sellerapi.dentira.com`;
	labsApiHost = `https://uk-labs-sellerapi.dentira.com`;
	apiKey = 'fb4a6b72-a08a-4331-8d95-c7046ec6cd22';
} else if (hostName === 'fr-seller.dentira.com') {
	host = 'FR';
	mainApiHost = `https://fr-api.dentira.com`;
	fileApiHost = 'https://fr-presign.dentira.com';
	procurementApiHost = `https://fr-sellerapi.dentira.com`;
	labsApiHost = `https://fr-labs-sellerapi.dentira.com`;
	apiKey = 'fb4a6b72-a08a-4331-8d95-c7046ec6cd22';
} else if (hostName === 'qaseller.dentira.com') {
	host = 'QA';
	mainApiHost = `https://qaapi.dentira.com`;
	fileApiHost = 'https://presign.dentira.com';
	procurementApiHost = `https://qasellerapi.dentira.com`;
	labsApiHost = `https://qa-labs-sellerapi.dentira.com`;
	apiKey = 'fb4a6b72-a08a-4331-8d95-c7046ec6cd22';
} else {
	host = 'QA';
	mainApiHost = `http://localhost:30002`;
	procurementApiHost = `http://localhost:30006`;
	labsApiHost = `http://localhost:30006`;
	fileApiHost = 'https://presign.dentira.com';
	apiKey = 'fb4a6b72-a08a-4331-8d95-c7046ec6cd22';
}

export const HOST = host;
export const MAIN_API_HOST = mainApiHost;
export const FILE_API_HOST = fileApiHost;
export const PROCUREMENT_API_HOST = procurementApiHost;
export const LABS_API_HOST = labsApiHost;
export const API_KEY = apiKey;